// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Discussion, Viewer } = initSchema(schema);

export {
  Discussion,
  Viewer
};